import axios from "axios";
import { API_URL } from "../../../const";

/*************** SALE DETAILS CREATE START *************** */
export const createSaleApi = (createData: any) => {
  const data = {
    CreateSaleToken: createData,
  };
  const url = `${API_URL}CreateSale`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** SALE DETAILS CREATE END *************** */

/*************** SALE DETAILS FETCH START *************** */
export const fetchSaleDetailsApi = (fetchData: any) => {
  const data = {
    FetchSaleDetailsToken: fetchData,
  };
  const url = `${API_URL}FetchSaleDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** SALE DETAILS FETCH END *************** */

/*************** SALE DETAILS UPDATE START *************** */
export const updateSaleApi = (updateData: any) => {
  const data = {
    UpdateSaleDetailsToken: updateData,
  };
  const url = `${API_URL}UpdateSale`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/*************** SALE DETAILS UPDATE END *************** */
